export default "__VITE_ASSET__BfuN$z4D__"